import { render, staticRenderFns } from "./CertificatesDownload.vue?vue&type=template&id=6932e965&scoped=true"
import script from "./CertificatesDownload.vue?vue&type=script&lang=js"
export * from "./CertificatesDownload.vue?vue&type=script&lang=js"
import style0 from "./CertificatesDownload.vue?vue&type=style&index=0&id=6932e965&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6932e965",
  null
  
)

export default component.exports